import classNames from "classnames";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { CheckIcon } from "../../../../../assets/icons";
import { ChevronDown } from "../../../../../assets/icons/chevronDown";
import "./index.scss";

export interface SelectOption {
  label: string;
  value: string;
}

interface SelectProps {
  options: SelectOption[];
  value: string | null;
  onSelect: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const Select = ({
  options,
  value,
  onSelect,
  placeholder = "Selecione...",
  className = "",
}: SelectProps) => {
  const [open, setOpen] = useState(false);

  const selectedLabel =
    options.find((opt) => opt.value === value)?.label || placeholder;

  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const handleSelect = (value: string) => {
    onSelect(value);
    setOpen(false);
  };

  return (
    <Dropdown
      className={`app-dropdown ${className}`}
      show={open}
      onToggle={(isOpen) => setOpen(isOpen)}
    >
      <Dropdown.Toggle
        as="button"
        className="dropdown-toggle-custom"
        onClick={() => setOpen((prev) => !prev)}
      >
        {selectedLabel}

        <button
          className={classNames("chevron-btn", open ? "open" : "")}
          onClick={toggleDropdown}
        >
          <ChevronDown />
        </button>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options.map((opt) => (
          <Dropdown.Item
            key={opt.value}
            active={value === opt.value}
            onClick={() => handleSelect(opt.value)}
          >
            {value === opt.value && <CheckIcon />}
            {opt.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Select;
